import { render, staticRenderFns } from "./SafetyReportConfigurationTable.vue?vue&type=template&id=18123087&scoped=true"
import script from "./SafetyReportConfigurationTable.vue?vue&type=script&lang=ts"
export * from "./SafetyReportConfigurationTable.vue?vue&type=script&lang=ts"
import style0 from "./SafetyReportConfigurationTable.vue?vue&type=style&index=0&id=18123087&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18123087",
  null
  
)

export default component.exports